import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { features as setFeature } from '../redux/slices/Tree/treeFeatures'
import { resetAllFilters } from '../redux/slices/Search/input'

/**
 * Limpia las features y los filtros cuando el usuario cambia de ciudad,
 * forzando una recarga de datos para el nuevo cantón.
 */
export const useCityReset = currentCity => {
  const dispatch = useDispatch()
  const previousCityRef = useRef(currentCity)

  useEffect(() => {
    if (previousCityRef.current && previousCityRef.current !== currentCity) {
      dispatch(setFeature({ type: 'FeatureCollection', features: [] }))
      dispatch(resetAllFilters())
    }
    previousCityRef.current = currentCity
  }, [currentCity, dispatch])
}
